export default __webpack_public_path__ + "static/media/figuremap57.7d65f991.png";